export default __webpack_public_path__ + "static/media/tickets_QR_Waiting.4ccad9ac.svg";